import Cookies from "js-cookie";

const state = {
  sidebar: {
    // opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    opened: false,
    withoutAnimation: false,
  },
  device: "desktop",
  isPcMode: true,
  isAndroid: false,
  version_api: "v2",
  localUrlAndroid: "",
  isWsError: false, //websoket连接不上，可以显示重连
  isRoloadWs: false, // 心跳机制发现问题，重连中
  singleFinger: true,
};

const mutations = {
  SET_ISWSERROE(state, bol) {
    state.isWsError = bol;
  },
  SET_ISROLOADWS(state, bol) {
    state.isRoloadWs = bol;
  },
  SET_ISPCMODE(state, bol) {
    state.isPcMode = bol;
  },
  // 设置是否是安卓
  SET_ISANDROID(state, bol) {
    state.isAndroid = bol && process.env.VUE_APP_PC !== "true";
  },
  //获取安卓当前上传图片的路劲
  SET_LOCAL_URL_ANDROID(state, localUrlAndroid) {
    state.localUrlAndroid = localUrlAndroid;
  },
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set("sidebarStatus", 1);
    } else {
      Cookies.set("sidebarStatus", 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set("sidebarStatus", 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
};

const actions = {
  toggleSideBar({ commit }) {
    commit("TOGGLE_SIDEBAR");
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit("TOGGLE_DEVICE", device);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
